/**
 * @class Constants
 * @description This is the constants service which provides all the constants
 */
export class Constants {
  public static readonly UPLOAD_TERMS_FILE_SIZE = 52428800; // 40MB

  public static readonly UPLOAD_IMAGE_SIZE = 1572864; // 1.5MB

  public static readonly UPLOAD_FLOOR_PLAN_IMAGE_SIZE = 3145928; // 3MB
  public static readonly UPLOAD_FLOOR_PLAN_AR_SIZE = 31457280; // 30MB

  public static readonly MIN_FIRSTNAME_LENGTH = 2;
  public static readonly MAX_FIRSTNAME_LENGTH = 100;

  public static readonly MIN_LASTNAME_LENGTH = 2;
  public static readonly MAX_LASTNAME_LENGTH = 100;

  public static readonly MAX_COMPANYNAME_LENGTH = 100;

  public static readonly MAX_EMAIL_LENGTH = 100;
  public static readonly MIN_PHONE_NUMBER_LENGTH = 3;
  public static readonly MAX_PHONE_NUMBER_LENGTH = 16;

  public static readonly NAME_REGEX = /^[A-Za-z][ \.A-Za-z0-9]+$/;
  public static readonly EMAIL_REGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,10}$/;
  public static readonly PHONE_REGEX = /^\d+$/;

  public static readonly MAX_ADDRESS_LINE2_LENGTH = 100;
  public static readonly MAX_AREA_LENGTH = 40;
  public static readonly MAX_STATE_LENGTH = 50;

  public static readonly MAX_COUNTRY_LENGTH = 50;
  public static readonly MAX_POSTCODE_LENGTH = 20;

  public static readonly PROJECT_TYPE = {
    1: {
      en: 'House',
      zh: '独栋别墅'
    },
    2: {
      en: 'Townhouse',
      zh: '联排别墅'
    },
    3: {
      en: 'Apartment',
      zh: '公寓'
    },
    4: {
      en: 'House & Land',
      zh: '土地别墅'
    }
  };

  public static readonly PROJECT_ASOECT_NAME_MAP = {
    1: {
      name: 'North'
    },
    N: {
      name: 'North'
    },
    2: {
      name: 'South'
    },
    S: {
      name: 'South'
    },
    3: {
      name: 'East'
    },
    E: {
      name: 'East'
    },
    4: {
      name: 'West'
    },
    W: {
      name: 'West'
    },
    5: {
      name: 'North-east'
    },
    NE: {
      name: 'North-east'
    },
    6: {
      name: 'North-west'
    },
    WN: {
      name: 'North-west'
    },
    7: {
      name: 'South-east'
    },
    ES: {
      name: 'South-east'
    },
    8: {
      name: 'South-west'
    },
    WS: {
      name: 'South-west'
    }
  };


  public static readonly STATUS = {
    0: {
      en: 'Under Approval',
      zh: '待认证',
      color: '#727272'
    },
    1: {
      en: 'Disabled',
      zh: '被禁用',
      color: '#ff7712'
    },
    2: {
      en: 'Approved',
      zh: '平台认证',
      color: '#4caf50'
    }
  };

}
